var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0318 24.1071C6.19304 24.1071 1.60897 20.1956 0.573394 14.5255C0.560507 14.4549 0.542417 14.3485 0.519125 14.2061L6.30469 14.2062C6.33005 14.2915 6.34949 14.3551 6.363 14.397C7.22078 17.0586 9.55062 18.4349 12.0318 18.4349C14.5172 18.4349 16.8506 17.0828 17.7049 14.4014C17.7186 14.3585 17.7382 14.2934 17.7639 14.2061H23.5445C23.5252 14.3251 23.5102 14.4142 23.4997 14.4732C22.4828 20.1715 17.8885 24.1071 12.0318 24.1071ZM12.0318 0C18.1389 0 22.8733 4.2404 23.6103 10.3647C23.6209 10.4524 23.6349 10.5849 23.6523 10.7622H17.9516C17.9352 10.6615 17.9224 10.5865 17.9131 10.537C17.309 7.30394 14.7621 5.67227 12.0318 5.67227C9.33282 5.67227 6.81293 7.26683 6.17203 10.4267C6.15717 10.5 6.13717 10.6118 6.11204 10.7622H0.411377C0.436564 10.5133 0.45728 10.3276 0.473527 10.2049C1.27301 4.16676 5.97799 0 12.0318 0Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_417",
    x1: 2.8848,
    y1: 2.59932,
    x2: 23.5911,
    y2: 23.3498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36CDCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingover);
export default __webpack_public_path__ + "static/media/Ringover.20b6e1f25788db10aff9e3dfa9d48d28.svg";
export { ForwardRef as ReactComponent };